import { useState } from 'react';
import { Thumbnail, type ThumbnailProps } from '@shopify/polaris';
import { ImageIcon } from '@shopify/polaris-icons';

type ProductThumbnailProps = Omit<ThumbnailProps, 'source'> & { source?: string | null };

export default function ProductThumbnail({ source, alt, ...props }: ProductThumbnailProps) {
    const [failedSource, setFailedSource] = useState<string>();
    const imageSource = source?.trim();
    const showImage = !!imageSource && imageSource !== failedSource;

    return (
        <span style={{ display: 'inline-flex', flexShrink: 0 }} onErrorCapture={() => setFailedSource(imageSource)}>
            <Thumbnail
                {...props}
                source={showImage ? imageSource : ImageIcon}
                alt={showImage ? alt : `No image available for ${alt}`}
            />
        </span>
    );
}
